import Template from '#client/components/Template';

const Empty = () => <Template />;

export default Empty;
